module.exports = __webpack_public_path__ + "img/flag_uk.351b3723.png";